// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8bfc64ed","453":"41e7b15c","732":"5259e410","977":"172aee54"}[chunkId] + ".chunk.js";
};